export var EnumCategoryLogs = /*#__PURE__*/ function (EnumCategoryLogs) {
    EnumCategoryLogs[EnumCategoryLogs["ADMINKA"] = 0] = "ADMINKA";
    EnumCategoryLogs[EnumCategoryLogs["ALGORITHMS"] = 1] = "ALGORITHMS";
    EnumCategoryLogs[EnumCategoryLogs["CORE"] = 2] = "CORE";
    return EnumCategoryLogs;
}({});
